// ticket-app-fe/src/index.js
   import React from 'react';
   import ReactDOM from 'react-dom/client';
   import { Amplify } from 'aws-amplify';
   import config from './amplify_outputs.json';
   import './index.css';
   import App from './App';
Amplify.configure({
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT,
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      defaultAuthorizationType: 'API_KEY',
      apiKey: process.env.REACT_APP_API_KEY
    }
  }
});



   const root = ReactDOM.createRoot(document.getElementById('root'));
   root.render(
     <React.StrictMode>
       <App />
     </React.StrictMode>
   );